"use strict";
exports.__esModule = true;
exports.BILL_STATUS_FINANCE_CHARGE_DAY = exports.BILL_STATUS_RENT_PAYMENT_STATUS = exports.BILL_STATUS_RENT_BILL_SECTION = void 0;
exports.BILL_STATUS_RENT_BILL_SECTION = {
    HEADER: 'Rent payment',
    SUBHEADER: 'Payment to property',
    AUTOPAY_TOGGLE: 'Rent autopay is',
    ESTIMATED: 'estimated',
    EPISODIC_NOT_PAID: 'After 1st payment'
};
exports.BILL_STATUS_RENT_PAYMENT_STATUS = {
    PAYMENTS: 'Payments to Flex',
    FINANCE_CHARGE: 'The {{processingFeePercentage}}% finance charge is collected on the {{day}} of each month. '
};
exports.BILL_STATUS_FINANCE_CHARGE_DAY = '21st';
